import React from 'react';
import { Box, TablePagination } from '@mui/material';

function AdminPagination({
  count,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
}) {
  if (!count) {
    return null;
  }

  return (
    <Box
      sx={{
        borderTop: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
      }}
    >
      <TablePagination
        component="div"
        count={count}
        page={page}
        onPageChange={onPageChange}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={onRowsPerPageChange}
        rowsPerPageOptions={[5, 10, 20, 50]}
        sx={{
          '.MuiTablePagination-toolbar': {
            px: { xs: 1.5, md: 2.5 },
            py: 0.5,
            flexWrap: 'wrap',
            gap: 1,
          },
          '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows': {
            color: 'text.secondary',
            fontSize: '0.92rem',
          },
        }}
      />
    </Box>
  );
}

export default AdminPagination;
